import { Component } from 'preact';
import style from './styles/RadioSelect.scss';

/**
 * @typedef {Object} SelectOption
 * @property {string}    value      Value
 * @property {string}    label      Label for the value
 */

/**
 * @typedef {Object} SelectChangeActionData
 * @property {string}    value     Input value
 */

/**
 * @property {SelectOption[]}   props.options        Array of options
 * @property {*}                props.value          Value of the selected option
 * @property {string}           props.name           Input name
 * @property {Function}         props.onChangeAction On change callback
 * @property {string}           props.className      Extra class name for input
 */
const RadioSelect = ({ options, value, name, onChangeAction, className }) => (
	<div className={style.wrapper}>
		{ options.map((option) => <RadioInput {...{ ...option, selected: option.value === value, name, onChangeAction, className }} />) }
	</div>
);

/**
 * @property {RadioInput}       props.onChangeAction     On change callback
 */
class RadioInput extends Component {
	onClick = () => {
		this.props.onChangeAction(this.props.name, {
			value: this.props.value,
			touched: true
		});
	};

	constructor(props) {
		const { onChangeAction } = props;
		if (!(onChangeAction instanceof Function)) {
			new Error('RadioInput expects onChangeAction prop to be a defined Function.');
		}
		super(props);
	}

	render({ value, selected, label, name, className }) {
		return (
			<div className={`custom-control custom-radio ${className ? className : ''} ${style.radio}`} onClick={this.onClick}>
				<input type="radio" className="custom-control-input" {...{ name, value, checked: selected }} />
				<label className="custom-control-label">{label}</label>
			</div>
		);
	}
}

export default RadioSelect;



// WEBPACK FOOTER //
// ./components/form/RadioSelect.js